// extracted by mini-css-extract-plugin
module.exports = {"element":"Form_element__2_roD","item":"Form_item__bgnfN","section":"Form_section__cvYO7","errors":"Form_errors__1Hx5r"};